import type { PayloadAction } from '@reduxjs/toolkit';
import type { IDialogMessage } from '../interface';
import { constructMessage } from '../util/message';
import type { DialogStorage } from './interface';

const reset = (state: DialogStorage, action: PayloadAction) => [];

const _indexesInStore = (state: DialogStorage, search: Partial<IDialogMessage>): number[] => {
    const matchingIndexes = state
        .map((item, index) => (item.id === search.id ? index : -1))
        .filter(index => index >= 0);
    return matchingIndexes;
};

const _updateStore = (state: DialogStorage, newData: Partial<IDialogMessage>): DialogStorage => {
    let stateReturn = [...state];

    const matchingIndexes = _indexesInStore(state, newData);

    if (matchingIndexes.length > 0) {
        stateReturn = stateReturn.map((item, index) =>
            matchingIndexes.includes(index) ? { ...item, ...newData } : item,
        );
    } else {
        stateReturn.push(constructMessage(newData));
    }

    return stateReturn;
};

const showPopUp = (state: DialogStorage, action: PayloadAction<Partial<IDialogMessage>>) =>
    _updateStore(state, {
        ...action.payload,
        show: true,
    });

const hidePopUp = (state: DialogStorage, action: PayloadAction<Partial<IDialogMessage>>) =>
    _updateStore(state, {
        ...action.payload,
        show: false,
    });

const removePopUp = (state: DialogStorage, action: PayloadAction<Partial<IDialogMessage>>) => {
    const matchingIndexes = _indexesInStore(state, action.payload);
    const newState = state.filter((_, index) => !matchingIndexes.includes(index));
    return newState;
};

const updatePopUp = (state: DialogStorage, action: PayloadAction<Partial<IDialogMessage>>) =>
    _updateStore(state, action.payload);

export default Object.freeze({
    reset,
    showPopUp,
    hidePopUp,
    removePopUp,
    updatePopUp,
});
